import { Box, SvgIcon } from '@mui/material';
import { red } from '@mui/material/colors';

export const EmergencyIcon = (props) => {
  return (
    <Box
      sx={{
        width: props.sx?.width || 14,
        height: props.sx?.height || 14,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        backgroundColor: red[600],
        borderRadius: '50%',
      }}
    >
      <SvgIcon {...props}>
        <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.3499 9.53184L9.80114 8L12.3499 6.46816C12.4935 6.38184 12.5426 6.19082 12.4597 6.04121L11.8593 4.95859C11.7765 4.80918 11.5929 4.75781 11.4493 4.84414L8.90057 6.37598V3.3125C8.90057 3.13984 8.76613 3 8.60038 3H7.39962C7.23387 3 7.09943 3.13984 7.09943 3.3125V6.37617L4.55072 4.84434C4.40709 4.75801 4.22353 4.80938 4.14065 4.95879L3.54027 6.04121C3.45739 6.19063 3.50652 6.38184 3.65015 6.46816L6.19886 8L3.65015 9.53184C3.50652 9.61816 3.45739 9.80938 3.54027 9.95879L4.14065 11.0414C4.22353 11.1908 4.40709 11.242 4.55072 11.1559L7.09943 9.62402V12.6875C7.09943 12.8602 7.23387 13 7.39962 13H8.60038C8.76613 13 8.90057 12.8602 8.90057 12.6875V9.62383L11.4493 11.1557C11.5929 11.242 11.7765 11.1908 11.8593 11.0412L12.4597 9.95859C12.5426 9.80918 12.4935 9.61816 12.3499 9.53184Z"
            fill="white"
          />
        </svg>
      </SvgIcon>
    </Box>
  );
};
